import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ManageCardsRoutingModule } from './manage-cards-routing.module';
import { ManageCardOnFileComponent } from './manage-card-on-file/manage-card-on-file.component';
import { AutopaySettingComponent } from './autopay-setting/autopay-setting.component';
import { AddNewCardComponent } from './add-new-card/add-new-card.component';
import { PipeModule } from '../../shared/pipe/pipe.module';
import { ManageCardsService } from './manage-cards.service';
import { ChangePrimaryCard } from './manage-card-on-file/manage-card-on-file.component';
import { ConfirmDeleteCard } from './manage-card-on-file/manage-card-on-file.component';
import { SuccessMessage } from './manage-card-on-file/manage-card-on-file.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatSelectModule,
  MatSidenavModule,
  MatTableModule,
  MatListModule,
  MatProgressSpinnerModule,
  MatSlideToggleModule, MatDatepickerModule
} from '@angular/material';
import { TextMaskModule } from 'angular2-text-mask';
import {PaymentusModule} from '../paymentus/paymentus.module';
import {
  ConfirmDeletePaymentMethod,
  ManagePaymentMethodsComponent,
  ManagePaymentsChangePrimaryCard
} from './manage-payment-methods/manage-card-on-file.component';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    CommonModule,
    ManageCardsRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    PipeModule.forRoot(),
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatSidenavModule,
    MatTableModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    TextMaskModule,
    MatDatepickerModule,
    PaymentusModule
  ],
  providers: [ManageCardsService],
  declarations: [
    ManageCardOnFileComponent,
    ManagePaymentMethodsComponent,
    AutopaySettingComponent,
    AddNewCardComponent,
    ChangePrimaryCard,
    ManagePaymentsChangePrimaryCard,
    SuccessMessage,
    ConfirmDeleteCard,
    ConfirmDeletePaymentMethod
  ],
  bootstrap: [ChangePrimaryCard, SuccessMessage, ConfirmDeleteCard, ConfirmDeletePaymentMethod, ManagePaymentsChangePrimaryCard],
})
export class ManageCardsModule { }



// WEBPACK FOOTER //
// ./src/app/payment/manage-cards/manage-cards.module.ts